import { PillRemovable } from '#components/atoms/pill/PillRemovable.tsx';
import { Tooltip } from '#components/atoms/tooltip/Tooltip.tsx';
import { Pill } from '../Pill.tsx';

const VARIANT_TOOLTIPS = {
  default: undefined,
  success: 'New tag',
  alert: 'Deleted tag',
} as const;

type Props = {
  onClick: () => void;
  label: string;
  variant?: 'default' | 'success' | 'alert';
  className?: string;
  disabled?: boolean;
  ref?: React.Ref<HTMLButtonElement>;
};

export function TagPillRemovable({ onClick, label, variant = 'default', disabled, className, ref }: Props) {
  const tooltip = VARIANT_TOOLTIPS[variant];

  if (disabled) {
    return (
      <Pill size="large" variant={variant} className={className}>
        {label}
      </Pill>
    );
  }

  if (tooltip) {
    return (
      <Tooltip
        content={tooltip}
        className={className}
        render={<PillRemovable size="large" variant={variant} onRemove={onClick} ref={ref} tabIndex={-1} />}
      >
        {label}
      </Tooltip>
    );
  }

  return (
    <PillRemovable size="large" variant={variant} className={className} onRemove={onClick} ref={ref} tabIndex={-1}>
      {label}
    </PillRemovable>
  );
}
